import { render } from "./movies.vue?vue&type=template&id=4d961bc0"
import script from "./movies.vue?vue&type=script&lang=js"
export * from "./movies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__